<template>
  <v-card v-if="formDialog">
    <v-toolbar dark color="primary" tabs>
      <v-btn icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('Customer Form') }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-tabs slot="extension" v-model="tab" dark color="primary" align-with-title>
        <v-tabs-slider color="secondary"></v-tabs-slider>

        <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <aru-auto-form
          v-model="formData"
          :form-configuration="config.identification_form"
          :submit-button="false"
          :dismiss-button="false"
        ></aru-auto-form>
      </v-tab-item>
      <v-tab-item>
        <aru-auto-form
          v-model="formData"
          :form-configuration="config.address_form"
          :submit-button="false"
          :dismiss-button="false"
        ></aru-auto-form>
        <!-- <customer-adresses-form></customer-adresses-form> -->
      </v-tab-item>
      <v-tab-item>
        <aru-auto-form
          v-model="formData"
          :form-configuration="config.bank_form"
          :submit-button="false"
          :dismiss-button="false"
        ></aru-auto-form>
        <!-- <customer-bank-form></customer-bank-form> -->
      </v-tab-item>
      <v-tab-item>
        <v-form ref="form" lazy-validation>
          <v-card :class="config.iae_form.class">
            <v-card-title v-if="config.iae_form.formTitle">
              <h3 class="headline my-0">{{ $t(config.iae_form.formTitle) }}</h3>
            </v-card-title>
            <div v-for="(iae, i) in formIae" :key="i">
              <div v-for="(group, g) in config.iae_form.groups" :key="g">
                <v-card-title v-if="group.title">
                  <h3 class="headline my-0">{{ $t(group.title) }}</h3>
                </v-card-title>
                <v-divider v-if="group.title" light></v-divider>
                <v-card-text class="py-0">
                  <aru-auto-group-field
                    :default-field-class="config.iae_form.defaultFieldClass"
                    v-model="formIae[i]"
                    :field-group="group"
                  ></aru-auto-group-field>
                </v-card-text>
              </div>
            </div>
          </v-card>
        </v-form>

        <!-- <customer-activity-form></customer-activity-form> -->
      </v-tab-item>
      <v-tab-item>
        <aru-auto-form
          v-model="formData"
          :form-configuration="config.juridic_form"
          :submit-button="false"
          :dismiss-button="false"
        ></aru-auto-form>
        <!-- <customer-fiscal-data-form></customer-fiscal-data-form> -->
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import AruAutoForm from '@/components/commons/form/AruAutoForm';
import AruAutoGroupField from '@/components/commons/form/AruAutoGroupField';

export default {
  components: {
    AruAutoForm,
    AruAutoGroupField,
  },
  props: {
    config: {
      type: Object,
    },
    editItem: {
      type: Object,
    },
    editIndex: {
      type: Number,
    },
  },
  data() {
    return {
      formData: {},
      formIae: [],
      tab: 0,
      items: [
        'Datos identificativos',
        'Domicilios',
        'Bancos',
        'Actividades',
        'Datos Jurídicos',
        'Obligaciones',
      ],

      formDialog: true,
      profile: 'customer',
      dateMenu: false,
      date: null,
      showPassword: false,
      consultants: [],
      role: [],
      roles: ['autonomous', 'pyme', 'employees'],
    };
  },
  mounted() {
    console.log({
      INSIDECUSTOMERDATAFORM: this.config,
      EDITEDITEM: this.editItem,
    });
  },
  methods: {
    close() {
      this.$emit('closeDialog', true);
    },
  },
  watch: {
    editItem: {
      handler: function(val, oldVal) {
        if (this.editItem.hasOwnProperty('fiscal_data') && this.editItem.fiscal_data.length) {
          console.log({ Watch_Edit_item: this.editItem.fiscal_data[0] });
          this.formData = this.editItem.fiscal_data[0];
          console.log({ formData: this.formData });
        }
        if (this.editItem.hasOwnProperty('fiscal_iae')) {
          console.log({ Watch_Edit_item_iae: this.editItem.fiscal_iae });
          this.formIae = this.editItem.fiscal_iae;
          console.log({ formIae: this.formIae });
        }
      },
      deep: true,
    },
  },
};
</script>

<style></style>
